<template>
	<div class="login layui-layout layui-layout-admin">
		<!-- <img class="logo2" src="../assets/logo2.png" /> -->
		<div class="box">
			<div class="logo">
				<img src="../assets/logo.png" @click="onWelcome" />
			</div>
			<div class="layui-form rgBoxs" action="">
				<div class="layui-form-item margin_b40">
					<div class="layui-input-block margin_l0">
						<input type="phone" maxlength="11" v-model="phones" name="phones" required lay-reqText="请输入登录账号" lay-verify="required"
						 placeholder="登录账号" autocomplete="off" class="layui-input">
					</div>
				</div>
				<div class="layui-form-item margin_b40">
					<div class="layui-input-block margin_l0">
						<input type="password" name="password" required lay-reqText="请输入登录密码" lay-verify="required" placeholder="登录密码"
						 autocomplete="off" class="layui-input">
					</div>
				</div>

				<div class="layui-form-item">
					<div class="layui-input-block margin_l0">
						<button class="layui-btn nextBtns pointer zt_color" lay-submit lay-filter="dlu">登录</button>
						<div class="f_row al_itm jc_sb color_70" style="margin-top:10px;color: #FFFFFF;font-size: 18px;">
							<span @click="regst(1)" class="pointer" style="margin-right:10px;font-size: 18px;">新用户注册</span>
							<span @click="regst(2)" class="pointer" style="font-size: 16px;">忘记密码</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="layui-footer align_center zt_color f_row al_itm jc_ct" style="left:0;color:#fff;">
			<span>© 桃琼之瑶SMT活动钢网</span>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'login',
		data() {
			return {
				forms: '',
				phones: ''
			}
		},
		created() {
			if (window.localStorage.getItem('phone')) {
				this.phones = window.localStorage.getItem('phone');
			}
			layui.use(['form', 'layer', 'element'], () => {
				this.forms = layui.form;
				var layer = layui.layer;
				var element = layui.element;
				this.forms.on('submit(dlu)', (e) => {
					this.delCookie('token');
					api.userLogin({
						phone: e.field.phones,
						password: e.field.password,
					}).then((res) => {
						console.log((res))
						if (res.code == 1) {
							window.localStorage.setItem('phone', e.field.phones)
							if (res.data.status == 0) {
								let time = 24 * 60 * 60 * 1000 * 7;
								let token = res.data.token;
								this.setCookie('token', token, time);
								this.$router.push({
									path: '/improving'
								});
							} else if (res.data.status == 1) {
								layer.msg('账号待审核', {
									icon: 2,
									anim: 6
								})
							} else if (res.data.status == 2) {
								let time = 24 * 60 * 60 * 1000 * 7;
								let token = res.data.token;
								this.setCookie('token', token, time);
								sessionStorage.setItem('tests', true);
								this.$router.replace({
									path: '/memberCenter'
								});
							} else if (res.data.status == 3) {
								layer.msg('账号审核不通过', {
									icon: 2,
									anim: 6
								})
							} else if (res.data.status == 4) {
								layer.msg('该账号已被冻结', {
									icon: 2,
									anim: 6
								})
							}
						} else {
							layer.msg(res.msg, {
								icon: 2,
								anim: 6
							})
						}
					})
				});
				this.forms.render();
			});
		},
		mounted() {

		},
		methods: {
			regst(e) {
				this.$router.push('register?types=' + e);
			},
			onWelcome() {
				window.location.href = 'https://mr.summary88.com/mrgw_qyd/#/welcome'
			},
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.login {
		height: 100%;
		min-height: 700px;
	}

	.box {
		height: 100%;
		background: url(../assets/background.jpg) no-repeat;
		background-size: cover;
		overflow: hidden;
	}

	.logo {
		width: 200px;
		text-align: center;
		margin: 150px auto 0;
	}

	.logo img {
		width: 200px;
		cursor: pointer;
		/* 		height: 250px;
		border-radius: 50%; */
	}

	.logo2 {
		width: 687;
		height: 380px;
		position: absolute;
		top: 0;
		left: 0;
		cursor: pointer;
	}

	.rgBoxs {
		width: 400px;
		font-size: 16px;
		margin: 30px auto;
	}

	.rgBoxs input {
		width: 100%;
		line-height: 45px;
		height: 45px;
		color: rgba(136, 136, 136, 1);
		text-align: left;
		font-family: Microsoft Yahei;
		border: 1px solid rgba(187, 187, 187, 1);
		border-radius: 5px;
	}

	.rgBoxs .sendCode {
		font-size: 16px;
		width: 106px;
		margin: 0 0 0 30px;
		text-align: center;
		border-radius: 0px;
		color: #fff;
	}

	.rgBoxs .nextBtns {
		width: 100%;
		line-height: 40px;
		border-radius: 0px;
		color: rgba(255, 255, 255, 1);
		font-size: 18px;
		text-align: center;
		font-family: SourceHanSansSC;
		border-radius: 5px;
		background: #4876FF !important;
	}

	.tkuan {
		font-family: SourceHanSansSC;
		position: fixed;
		background: #fff;
		padding: 0 30px;
		box-sizing: border-box;
		left: 20%;
		top: 7.5%;
		width: 60%;
		height: 85%;
	}

	.tkuan .titles {
		font-size: 20px;
		padding: 10px 0;
	}

	.tkuan textarea {
		width: 100%;
		border: none;
		font-size: 16px;
		background: #fff;
		height: 100%;
		resize: none;
		overflow-y: scroll;
	}

	.oks {
		width: 30%;
		background: #4876FF;
		color: #fff;
		line-height: 35px;
		text-align: center;
		font-size: 16px;
		border-radius: 0px;
		margin: 4px auto 8px;
	}
</style>



// WEBPACK FOOTER //
// src/components/login.vue